import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';

import * as styles from './thumbnails-slider.scss';

const TIMER = 2000;

interface Props {
  slides: string[];
}
export const ThumbnailsSlider = ({ slides }: Props) => {
  const intl = useIntl();
  const [currentSlideInd, setCurrentSlideInd] = useState(0);
  const [isSliding, setIsSliding] = useState(false);
  const interval = useRef<ReturnType<typeof setTimeout> | null>(null);

  const startSliding = () => {
    setIsSliding(true);
  };

  const stopSliding = () => {
    setIsSliding(false);
  };

  useEffect(() => {
    if (isSliding && slides.length > 1) {
      interval.current = setInterval(() => {
        if (currentSlideInd === slides.length - 1) {
          return setCurrentSlideInd(0);
        }
        return setCurrentSlideInd(currentSlideInd + 1);
      }, TIMER);
    } else {
      interval.current && clearInterval(interval.current);
    }
    return () => (interval.current ? clearInterval(interval.current) : undefined);
  }, [isSliding, currentSlideInd, slides]);

  return (
    <div className={classNames(styles.carouselContainer)} onMouseEnter={startSliding} onMouseLeave={stopSliding}>
      {slides.map(slide => (
        <img key={slide} src={slide} alt="thumbnail" style={{ transform: `translate(-${currentSlideInd * 100}%)` }} />
      ))}
      <p className={classNames(styles.sliderIndication)}>
        {intl.formatMessage(
          { id: 'reporting.slide_i_of_n', defaultMessage: '{slide_i} of {total}' },
          { slide_i: currentSlideInd + 1, total: slides.length }
        )}
      </p>
    </div>
  );
};
